import React, { useState } from "react";
import axios from "../../axios/axios";
import { Link } from "react-router-dom";

const getStatusDetails = (status) => {
  switch (status) {
    case 1:
      return { text: "New Order", className: " bg-primary text-light" };
    case 2:
      return { text: "In Progress", className: "bg-warning text-light" };
    case 3:
      return { text: "On Hold", className: "bg-secondary text-light" };
    case 4:
      return { text: "In QC", className: "bg-info text-dark" };
    case 5:
      return { text: "Sample Sent", className: "bg-success text-light" };
    case 6:
      return { text: "In Revision", className: "bg-info text-light" };
    case 7:
      return { text: "Cancelled", className: "bg-danger text-light" };
    case 8:
      return { text: "Completed", className: "bg-success text-light" };
    default:
      return { text: "Unknown", className: "bg-dark text-light" };
  }
};

const getOrderType = (model) => {
  switch (model) {
    case "weddingAlbum":
      return "album-design";
    case "videoEditing":
      return "video-editing";
    case "realEstate":
      return "real-estate";
    case "culling":
      return "culling";
    case "retouching":
      return "retouching";
    default:
      return "color-correction";
  }
};

const Order = ({ val, setSelectedOrder, isLoading, billingType }) => {
  const [feedback, setFeedback] = useState("");
  const [sampleStatus, setSampleStatus] = useState(""); // New

  const { text, className } = getStatusDetails(val.status);

  const handlePayment = (order) => {
    console.log("Selected order:", order);
    setSelectedOrder(order);
  };

  const handleSubmitFeedback = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("user/sampleFeedback", {
        orderId: val._id,
        feedback,
        modelType: val.model,
        sampleStatus,
      });

      if (res.status === 200) {
        alert("Feedback submitted successfully!");
        setFeedback("");
        setSampleStatus(""); // Reset
      }
    } catch (err) {
      console.error("Error submitting feedback", err);
    }
  };

  return (
    <React.Fragment>
      <tr className="table-light">
        <td className="fs-14">{val._id}</td>
        <td className="fs-14">
          {val.paymentStatus === "paid" ? (
            <button
              className="btn btn-success px-2 py-1 rounded text-light fs-14"
              disabled
            >
              Paid
            </button>
          ) : billingType === "monthly" ? (
            <span className="text-muted">Billed Monthly</span>
          ) : (
            <button
              className="btn bg_maincolor px-2 py-1 rounded text-light fs-14"
              onClick={() => handlePayment(val)}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Pay with PayPal"}
            </button>
          )}
        </td>

        <td className="fs-14">{val.order_name}</td>
        <td className="fs-14">{val.serviceId?.service}</td>
        <td className="fs-14">{val.quantity}</td>
        <td className="fs-14">${val.price}</td>
        <td className="fs-14">{val.message}</td>
        {/* <td className="fs-14">{val.fileLocation}</td> */}
        <td>
          {val.fileLocation && (
            <a
              href={val.fileLocation}
              className="fs-14 text-decoration-none color-primary"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg_maincolor text-light px-2 py-1 rounded">
                Download
              </button>
            </a>
          )}
        </td>
        <td className="fs-14">
          <button className={`btn text-center p-2 rounded ${className}`}>
            {text}
          </button>
        </td>
        <td className="fs-14">
          <Link
            to={`/upload-files/${val._id}?type=${getOrderType(val.model)}`}
            className={`btn btn-secondary text-white text-center p-2 rounded`}
          >
            Upload Files
          </Link>
        </td>
      </tr>

      {val.status === 5 && (
        <tr>
          <td colSpan="10">
            <div className="d-flex flex-column gap-2 p-2 bg-light rounded">
              <input
                type="text"
                className="form-control"
                placeholder="Enter sample feedback"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
              <select
                className="form-select"
                value={sampleStatus}
                onChange={(e) => setSampleStatus(e.target.value)}
              >
                <option value="">-- Select Sample Status --</option>
                <option value="approved">Approve Sample</option>
                <option value="declined">Decline Sample</option>
              </select>
              <button
                onClick={handleSubmitFeedback}
                className="btn bg_maincolor text-light fs-14"
              >
                Submit
              </button>
            </div>
          </td>
        </tr>
      )}
    </React.Fragment>
  );
};

export default Order;
